/**
 * Formats a timestamp into a localized time string (HH:MM format)
 */
export const formatMessageTime = (time: string | number): string => {
  if (!time) return '';

  // Parse the input date string
  const date = new Date(time);

  // Get hours and minutes in local time
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Return the formatted time
  return `${hours}:${minutes}`;
};
